import React from "react";
import BoardOfDirectorsSection from "../../components/Investor/BoardOfDirectors.tsx";
import MetaComponent from "../../components/CommonComponents/MetaComponent.tsx";
const BoardOfDirectors = () => {
  return (
    <>
      <MetaComponent
        title="Learn About Our Company's Board of Directors | Aptech Limited"
        desc="Aptech Limited has a competent company board of directors, with each qualified member of the board contributing to its leadership and vision. Explore now."
        keywords="Board of Directors, Leadership Team, CSR Committee"
      />
      <div>
        <BoardOfDirectorsSection />
      </div>
    </>
  );
};

export default BoardOfDirectors;
